// extracted by mini-css-extract-plugin
export default {"custom_table_container":"index_custom_table_container__OkIi2","empty_state_text":"index_empty_state_text__kmv4R","no_data":"index_no_data__FLh1e"};